import styled, { css } from 'styled-components';

// Import utilites
import { flex } from 'components/styles';

//Import styles
import { customMinResponsive, size } from 'components/styles';

export const AuthenticationWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 100vh;
	background-color: ${({ theme: { body } }) => body.bg.primary};

	${customMinResponsive(
		size.medium,
		css`
			flex-direction: row;
			background-color: ${({ theme: { body } }) => body.bg.primary};
		`
	)}
`;

export const LogoContainer = styled.figure`
	display: none;
	${customMinResponsive(
		size.medium,
		css`
			flex: 1 1 50%;
			max-width: 50%;
			${flex()}
			background: ${({ background }) => `url(${background}) top center`};
			background-size: cover;
			background-repeat: no-repeat;
			padding: 0 3rem;
			margin-bottom: 0;
		`
	)}
`;

export const StyledLogo = styled.img`
	width: 80%;
	margin: 0 auto;
	filter: ${({ isContrast }) => (isContrast ? 'grayscale(1)' : 'grayscale(0)')};
`;

export const AuthenticationContainer = styled.div`
	width: 100%;
	${customMinResponsive(
		size.medium,
		css`
			flex: 1 1 50%;
			max-width: 50%;
			${flex()}
		`
	)}
`;

export const AuthenticationBox = styled.div`
	width: 100%;
	margin: 0 auto;
`;
